import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { SavedOrder } from "../orderTypes";
import type { OrderTodos } from "../ordersApi";
import { updateOrderTodos } from "../ordersApi";
import { isListOrdersQuery } from "../useOrder";
import { useSnackbar } from "notistack";

const ORDERS_QUERY_KEY = "orders";

export const useOrderTodos = (orderId: string) => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const updateOrderTodosMutation = useMutation<
    SavedOrder,
    unknown,
    {
      orderId: string;
      update: { todos: OrderTodos };
    }
  >({
    mutationFn: ({ orderId, update }) => updateOrderTodos(orderId, update),
    onSuccess: async (data) => {
      enqueueSnackbar("Zadania do zamówienia zostały zaktualizowane", { variant: "success" });
      queryClient.setQueryData([ORDERS_QUERY_KEY, orderId], data);
      await queryClient.invalidateQueries({ predicate: isListOrdersQuery });
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się zaktualizować zadań do zamówienia. Powód: ${(error as Error).message}`, {
        variant: "error",
      });
    },
  });

  return {
    onUpdateTodos: (todos: OrderTodos) => updateOrderTodosMutation.mutateAsync({ orderId, update: { todos } }),
  };
};
